import * as React from "react";
import { Clock, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const contactDetails = [{
  icon: MapPin,
  label: "Our Clinic",
  data: ["Foloune House, Gladstonos 120, Unit 5", "Limassol 3032"]
}, {
  icon: Phone,
  label: "Get in Touch",
  data: ["Phone: 96117140", "Email: bodywerkscy@gmail.com", "Mobile and Message: 96117140", "Telegram: 96117140", "Landline: +357 25 954 014"]
}, {
  icon: Clock,
  label: "Clinic Hours",
  data: ["Mon, Wed: 4:00 PM - 7:30 PM", "Tue, Thu: 9:30 AM - 12:30 PM", "Fri: 3:00 PM - 6:30 PM", "Closed Sat & Sun"]
}];
export default function VisitUs() {
  return <section data-section-id="140460" id="clinic-details" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden shadow-xl border border-border">
          
          {}
          <div className="relative h-[400px] lg:h-auto bg-muted">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.6422937950147!2d33.044!3d34.678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c39082f30de0d5%3A0x6b415176063e5e6e!2sLimassol%2C%20Cyprus!5e0!3m2!1sen!2sus!4v1621530000000!5m2!1sen!2sus" className="absolute inset-0 w-full h-full border-0 filter grayscale-[0.2] contrast-[1.05]" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Our Location" />
          </div>

          {}
          <div className="bg-card p-10 md:p-16 lg:p-20 flex flex-col justify-center">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-12">
              Clinic Details
            </h2>

            <div className="space-y-10 mb-14">
              {contactDetails.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-5">
                  <div className="bg-background p-3 rounded-full shadow-sm border border-border/50 shrink-0">
                    <item.icon className="w-6 h-6 text-[#F58220]" />
                  </div>
                  <div className="pt-1">
                    <h3 className="font-sans text-2xl font-semibold text-foreground mb-2">
                      {item.label}
                    </h3>
                    <div className="space-y-1">
                      {item.data.map((line, j) => <p key={j} className="font-sans text-base text-[#F58220]">
                          {line}
                        </p>)}
                    </div>
                  </div>
                </div>)}
            </div>

            <div className="mt-auto pt-4">
              <Button asChild className="font-sans text-sm font-semibold uppercase tracking-widest bg-primary text-primary-foreground rounded-full px-8 py-6 h-auto hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/20 transition-all duration-300">
                <Link to="https://maps.google.com" newTab>
                  Get Directions
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}